import { Component, EventEmitter, Output } from '@angular/core';

import { EntityType, EntityTypeLabel } from '@features/contacts/models';
import { SelectionItem } from '@shared/components/selection/selection-item';
import { ApplicantIconPipe } from '@shared/pipes/icon/applicant-icon.pipe';

@Component({
  selector: 'spark-contacts-entity-type-selector',
  templateUrl: './entity-type-selector.component.html'
})
export class EntityTypeSelectorComponent {
  @Output() selected = new EventEmitter<EntityType>();
  @Output() closed = new EventEmitter<boolean>();

  private applicantIcon = new ApplicantIconPipe();

  items = Object.values(EntityType).map(
    (k) =>
      new SelectionItem(
        EntityTypeLabel[k],
        () => {
          this.selected.emit(k);
        },
        this.applicantIcon.transform(k)
      )
  );

  closeModal() {
    this.closed.emit(true);
  }
}
